import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['dragContainer']

  connect() {
    var dragula = require('dragula');

    this.drake = dragula({
      containers: Array.from(this.dragContainerTargets),
      invalid: (el, handle) => el.classList.contains('no-drag')
    });

    this.drake.on('drop', this.changePosition.bind(this))
  }

  changePosition(el, target, source, sibling) {
    var boardId = this.element.getAttribute("data-board-id");
    var elementId = el.getAttribute("data-preloaded-field-id");
    var siblingId = null;

    if(sibling !== null) {
      siblingId = sibling.getAttribute("data-preloaded-field-id");
    }

    let data = { field_id: elementId, sibling_field_id: siblingId };
    
    fetch(`/${accountId}/boards/${boardId}/update_preloaded_fields_position`, {
      method: "PATCH",
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) {
        throw response
      }
      return response.json();
    }).then((responseJson) => {
      if(responseJson.sibling_not_present === true) {
        sibling = el.previousElementSibling
      }

      let elStepSettings = el.querySelector(".item-settings");
      let siblingStepSettings = sibling.querySelector(".item-settings");
      elStepSettings.innerHTML = responseJson.current_field_setting;
      siblingStepSettings.innerHTML = responseJson.sibling_field_setting;
    }).catch((error) => {
      console.log(error)
    })
  }

}